import { makeStyles } from "tss-react/mui";
import { MiButton, MiPlaceholderArea } from "@miplatform/components";
import { BUTTON_VARIANTS, TYPOGRAPHY_VARIANTS } from "@miplatform/constants";
import { Box, Typography, useTheme } from "@mui/material";

export function OptionDetails({
  selectedOption,
  isLoading,
  onSave,
  onBack,
  setShowOptionSummary,
}) {
  const { classes } = useStyles();
  const theme = useTheme();

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography
          className={classes.optionName}
          variant={TYPOGRAPHY_VARIANTS.BODY1}
        >
          {`Option Name: `}
          <span className={classes.highlight}>{selectedOption?.name}</span>
        </Typography>
        <Box className={classes.optionActions}>
          <MiButton
            title="Summary & Markup"
            variant={BUTTON_VARIANTS.TEXT}
            onClick={() => setShowOptionSummary(true)}
            disabled={isLoading}
          />
          <MiButton
            title="Back"
            variant={BUTTON_VARIANTS.OUTLINED}
            onClick={onBack}
            disabled={isLoading}
          />
          <MiButton
            title="Save Option"
            variant={BUTTON_VARIANTS.CONTAINED}
            onClick={onSave}
            disabled={isLoading}
          />
        </Box>
      </Box>
      <Box flex={1}>
        <MiPlaceholderArea
          showLogo
          helperText={`Add and/or remove items or areas on \n the bid to begin creating your option.`}
          containerStyle={{
            backgroundColor: theme.palette.white.main,
            height: "100%",
            gap: theme.spacing(1),
            whiteSpace: "pre-wrap",
            lineHeight: 0,
          }}
        />
      </Box>
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    margin: 0,
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  optionActions: {
    display: "flex",
    gap: theme.spacing(2),
  },
  optionName: {
    fontWeight: theme.fontWeight.bold,
  },
  highlight: {
    color: theme.palette.primary.main,
  },
}));
